import {createApp} from 'vue'
import App from '@/App.vue'
import pinia from '@/store/pinia'
import router from '@/router'
import AuthPlugin from '@/plugins/auth'
import FiltersPlugin from '@/filtersPlugin'
import vuetify from './plugins/vuetify'
import './assets/css/style.scss'
import './assets/css/animations.scss'
import './assets/css/ds-debug.scss'
if (localStorage.getItem('dsDebug') === '1') {
  document.documentElement.classList.add('ds-debug')
}
import globalInputMaxLength from '@/mixins/globalInputMaxLength'
import {initSentry} from '@/sentry'
import {registerPreloadErrorRecovery} from '@/services/preloadRecovery'
import {FESettingsInstance} from './auth/FESettings'
import {getConfig} from '@/api/config'
import ThunderLoader from '@/components/ThunderLoader.vue'
import TsLoadingOverlay from '@/components/generic/TsLoadingOverlay.vue'
import IconBtn from '@/components/IconBtn.vue'
import SSlider from '@/components/SSlider.vue'
import SDateField from '@/components/SDateField.vue'

// Registered before startup: a tab left open across a deploy hits this on its first lazy
// import, which can happen before the app has finished mounting.
registerPreloadErrorRecovery()

// Inject getConfig function into FESettingsInstance
FESettingsInstance.getConfig = getConfig
window.feSettings = FESettingsInstance

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)
app.use(AuthPlugin)
app.use(FiltersPlugin)

// Registers global mixin to set maxlength on all inputs and textareas
app.mixin(globalInputMaxLength)

document.addEventListener('focusin', (e) => {
  const target = e.target as HTMLElement
  if (target.tagName === 'INPUT' && target.closest('.v-autocomplete, .v-combobox')) {
    (target as HTMLInputElement).select()
  }
})

// Register global components
app.component('ThunderLoader', ThunderLoader)
app.component('TsLoadingOverlay', TsLoadingOverlay)
app.component('IconBtn', IconBtn)
app.component('SSlider', SSlider)
app.component('SDateField', SDateField)

initSentry(app, router)

app.mount('#app')
